module.exports = require('./helpers/bundle-url').getBundleURL('8g68e') + "ot7-135x180-neon-bg-pattern.a7c848fa.webp";